import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,       // 2 minutes - data stays fresh
      gcTime: 1000 * 60 * 10,          // 10 minutes - cache kept in memory
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
    mutations: {
      retry: 1,
    },
  },
});

// Query key factories for consistent cache keys
export const queryKeys = {
  dashboardMetrics: (userId) => ['dashboardMetrics', userId],
  workoutLogs: (userId, page, filters) => ['workoutLogs', userId, page, filters],
  workoutLogsAll: (userId) => ['workoutLogs', userId],
};
